// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicB2cV2GetOffersRequest,
  TPublicB2cV2GetOffersModel,
  IMappers,
  TPublicB2cV2GetOffersResponse,
  TPublicB2cV2GetOffersResponse_1,
  TPublicB2cV2GetOffersResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TPublicB2cV2GetOffersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'mortgage-broker-calculator',
  pathApi: '/b2c/v2/get-offers/',
  requestType: 'json',
} as TPublicB2cV2GetOffersModel;

export function createPublicB2cV2GetOffersModel(parameters: TPublicB2cV2GetOffersRequest): TPublicB2cV2GetOffersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicB2cV2GetOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicB2cV2GetOffersRequest;
}

export async function fetchPublicB2cV2GetOffers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicB2cV2GetOffersOptions<TResponse200, TResponse400>): Promise<
  TPublicB2cV2GetOffersResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createPublicB2cV2GetOffersModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicB2cV2GetOffersResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublicB2cV2GetOffersResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicB2cV2GetOffersResponse;
}
